// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__38Iou","title":"InfoRow_title__2L9lV"};